import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionRevisionRerunAutomationsPathParameters } from 'api/actions/revision-revision-rerun-automations/revision-revision-rerun-automations-path-parameters';
import { RevisionRevisionRerunAutomationsResponse } from 'api/actions/revision-revision-rerun-automations/revision-revision-rerun-automations-response';

type RevisionRevisionRerunAutomationsQueryParameters = Record<string, any>;

/**
 * The path of the RevisionRevisionRerunAutomations action.
 */
export const revisionRevisionRerunAutomationsActionPath = new SweetPath<
  keyof RevisionRevisionRerunAutomationsPathParameters
>('/api/revision/revision-rerun-automations/{revisionId}/{oldStatusId}/{newStatusId}', { path: '{param}' });

/**
 * Creates a contextualized RevisionRevisionRerunAutomations actions.
 */
export default function createRevisionRevisionRerunAutomationsAction(axios: AxiosInstance) {
  return function revisionRevisionRerunAutomationsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionRevisionRerunAutomationsPathParameters;
    query?: RevisionRevisionRerunAutomationsQueryParameters;
  }) {
    const path = revisionRevisionRerunAutomationsActionPath.insert(parameters);

    return axios.request<RevisionRevisionRerunAutomationsResponse, RevisionRevisionRerunAutomationsResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
